import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Settings } from "../../models/interfaces/settings.model";
import { Status } from "../../models/interfaces/status.model";
import { SettingsPage } from "../../pages/settings/settings";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-settings_add",
  templateUrl: "settings_add.html",
})
export class SettingsAddPage {
  private loading: any;
  // private settings;
  private setting;
  private styleName: string ="";
  private settingForm: FormGroup;
  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController,
  ) {
    console.log("SettingsAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.setting = this.navParams.get("settings");
    this.settingForm = this.formBuilder.group({
      "se_attribute1": [""],
      "se_attribute2": [""],
      "se_class": ["" , [Validators.required]],
      "se_key_name": ["", [Validators.required]],
      "se_key_value": ["" , [Validators.required]],
      "se_name_description": ["", [Validators.required]],
      "se_order": [""],
    });
  }
  private ionViewWillEnter() {
    console.log("SettingsAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("SettingsAddPage onInitPage");
  }

  private goback() {
    console.log("SettingsAddPage goback");
    this.navCtrl.pop();
  }

  private addSetting() {
    console.log("SettingsAddPage addMember");
    if (this.settingForm.dirty && this.settingForm.valid) {
      this.db.dbCol({ "action": "insert", "mapObject": "settings", ...this.settingForm.value })
        .subscribe((ret3) => {
          this.navCtrl.pop();
        });
    }
  }
  private ngOnDestroy() {
    console.log("SettingsAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings_add.ts